import { appLogging } from "./appLogging";

export const { logging } = appLogging;
